import React, { useCallback, useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import Icon from 'react-icons-kit'
import { chevronLeft } from 'react-icons-kit/feather'
import Requests from '../../../../utils/Requests/Index'
import { dateFormate } from '../../../../utils/helpers'

import LoadingComponent from '../../../../components/loading/Index'

const Show = () => {
    const { id } = useParams()
    const [isLoading, setLoading] = useState(true)
    const [item, setItem] = useState(null)
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })

    // Fetch data
    const fetchData = useCallback(async () => {
        const data = await Requests.ProfilesByProfession.Show(id, header)
        if (data) {
            setItem(data)
            setLoading(false)
        }
        setLoading(false)
    }, [id, header])


    useEffect(() => {
        fetchData()
    }, [id, header, fetchData])


    if (isLoading) return <LoadingComponent />

    return (
        <div className="store-story pb-4">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-padding">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header p-3 p-lg-4 bg-white">
                                <div className="d-flex justify-content-between">
                                    <div><h6 className="mb-0">Show Profile Profession</h6></div>
                                    <div className="ml-auto">
                                        <Link
                                            to="/dashboard/website/profiles-by-profession"
                                            type="button"
                                            className="btn shadow-none rounded-circle"
                                        >
                                            <Icon icon={chevronLeft} size={22} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-4">
                                <div className="d-lg-flex">
                                    <div className="pr-lg-5 mb-4">
                                        <img
                                            src={item.image}
                                            className="img-fluid"
                                            alt="..."
                                            style={{ width: 200 }}
                                        />
                                    </div>
                                    <div>
                                        <table className="table table-md table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td>Meta Title</td>
                                                    <td>{item.metaTitle || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Meta Description</td>
                                                    <td>{item.metaDescription || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Title</td>
                                                    <td>{item.title || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Sub Banner Title</td>
                                                    <td>{item.subBannerTitle || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Banner Description</td>
                                                    <td>{item.bannerDescription || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>District</td>
                                                    <td>{item.district || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Profession</td>
                                                    <td>{item.profession || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Description</td>
                                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                                </tr>
                                                <tr>
                                                    <td>Profile Verification</td>
                                                    <td>{item.profileVerification || 'N/A'}</td>
                                                </tr>
                                                <tr>
                                                    <td>FQA</td>
                                                    <thead>
                                                    <tr className="border-bottom">
                                                    <td className="text-center sl-td">SL</td>
                                                        <td>Question</td>
                                                        <td>Answer</td>
                                                    </tr>
                                                </thead>
                                                    <tbody>
                                                        {item.faq.map((faq, index) => (
                                                            <tr key={index}>
                                                            <td className="text-center sl-td">{index + 1}</td>
                                                            <td>{faq.question}</td>
                                                            <td>{faq.answer}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    
                                                        
                                                </tr>
                                                
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <br />

                                {item.admin ?
                                    <div className="text-end">
                                        <h6><i>Created by</i></h6>
                                        <p className="mb-0">{item.admin.name}</p>
                                        <p className="mb-0">{item.admin.email}</p>
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Show;